<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="区域" prop="organizationName">
              <el-input
                v-model="searchForm.organizationName"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="经销商" prop="customerName">
              <el-input
                v-model="searchForm.customerName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>

            <el-form-item label="经销商经营状态" prop="businessStatus">
              <el-select v-model="searchForm.businessStatus" clearable @change="onSearch">
                <el-option v-for="item in businessStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="门店" prop="storeName">
              <el-input
                v-model="searchForm.storeName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="门店是否有效" prop="storeStatus">
              <el-select v-model="searchForm.storeStatus" clearable @change="onSearch">
                <el-option v-for="item in storeStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="职员编码" prop="staffCode">
              <el-input
                v-model="searchForm.staffCode"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="职员名称" prop="staffName">
              <el-input
                v-model="searchForm.staffName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否离职" prop="staffStatus">
              <el-select v-model="searchForm.staffStatus" clearable @change="onSearch">
                <el-option v-for="item in staffStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="钱包类型" prop="walletType">
              <el-select v-model="searchForm.walletType" clearable @change="onSearch">
                <el-option v-for="item in walletTypeStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提现时间" prop="updatedTime">
              <!-- <el-date-picker
                class="date-input"
                size="small"
                v-model="searchForm.updatedTime"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="-"
                start-placeholder="起始时间"
                end-placeholder="截至时间"
              >
              </el-date-picker> -->
              <q-date-picker startFiled="createTimeStart" endFiled="createTimeEnd" v-model="searchForm" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="handleAdd(null, 1)">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="organizationName" label="区域" align="center" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column prop="customerName" label="经销商" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column  label="经销商经营状态" align="center" width="120">
            <template slot-scope="scope">
              <span>{{scope.row.businessStatus | businessStatus}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="storeName" label="门店" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="门店是否有效" align="center" width="110">
            <template slot-scope="scope">
              <span>{{scope.row.storeStatus == '0' ? '有效' : '无效'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="staffCode" label="职员编码" align="center" width="160"></el-table-column>
          <el-table-column prop="staffName" label="职员" align="center" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="职员是否离职" align="center" width="120" >
            <template slot-scope="scope">
              <span>{{scope.row.staffStatus == '1' ? '是' : '否'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="walletTypeString" label="提现类型" align="center" width="120"></el-table-column>
          <el-table-column prop="amount" label="提现金额(元)" align="center" width="120"></el-table-column>
          <el-table-column prop="walletTypeString" label="钱包类型" align="center" width="120"></el-table-column>
          <el-table-column prop="createTime" label="提现时间" align="center" width="160"></el-table-column>
          <el-table-column  prop="withdrawalStatus"  label="提现状态" align="center" width="120">
            <template slot-scope="scope">
              <span>{{scope.row.withdrawalStatus | withdrawalStatus}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注"  align="center" show-overflow-tooltip></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import moment from 'moment';
export default {
  name: "withdrawalList",
  mixins: [tableMixin,pagePathMixin],
  data() {
    return {
      searchForm: {
        organizationName:'',
        customerName:'',
        businessStatus: "",
        storeName: "",
        storeStatus: "",
        staffCode: "",
        staffName: "",
        staffStatus: "",
        createTimeStart: "",
        createTimeEnd: "",
        walletType: ""
      },
      businessStatus: [ 
        {value: '', label: '全部'},
        {value: 1, label: '正常营业'},
        {value: 2, label: '预停业'},
        {value: 3, label: '已停业'},
        {value: 4, label: '预营业'},
        {value: 5, label: '未开业停用'},
        {value: 6, label: '经营异常'},
      ],
      storeStatus: [
        {value: '', label: '全部'},
        {value: 0, label: '有效'},
        {value: 1, label: '无效'},
      ],
      staffStatus: [
        {value: '', label: '全部'},
        {value: 0, label: '否'},
        {value: 1, label: '是'},
      ],
      walletTypeStatus: [
        {value: '', label: '全部'},
        {value: 1, label: '老钱包'},
        {value: 8, label: '新钱包'},
      ],
      panelData: {},

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      actionType: 1,
      isShowAdd: false,
      modifyData: null,
    };
  },
  methods: {
    init() {
      this.onSearch();
      this.getOrgBoardInfo();
    },
    getOrgBoardInfo() {
      this.$api.dataReport.orgBoardInfo().then((res) => {
        this.panelData = res.data;
      });
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .withdrawalPageList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.initDate()
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    handleAdd(row, actionType) {
      this.actionType = actionType;
      this.modifyData = row || null;
      this.isShowAdd = true;

      if (actionType == 3) {
        this.openSubPage({
          name: "manageList",
          params: row,
        });
      } else if (actionType == 1) {
        let params = {
          ...this.filterParam,
        };
        this.$api.common.doExport("withdrawalPageList", params).then(() => {
          this.$message.success("导出操作成功，请前往导出记录查看详情");
        });
      }
    },
    initDate() {
      this.searchForm.createTimeStart = ''
      this.searchForm.createTimeEnd = ''
      this.$refs.dateRef.reset()
    }
  },
  mounted() {
    this.init();
  },
  filters: {
    businessStatus(value) {
      let map = {
        1:'正常营业',
        2:'预停业',
        3:'已停业',
        4:'预营业',
        5:'未开业停用',
        6:'经营异常'
      }
      return map[value]
    },
    withdrawalStatus(value) {
      let map = {
        1:'成功',
        0: '未处理',
        '-1': '失败',
        2: '处理中'
      }
      return map[value]
    }
  },
};
</script>
<style lang="stylus" scoped>
.date-input {
  width 220px !important
}

</style>
